module.exports = __webpack_public_path__ + "static/img/index-course.ec32d54.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/index-course.png
// module id = m4bc
// module chunks = 1